import {
  PublishParams,
  CommercialScheduleFields,
  CommercialScheduleListParams,
  CommercialScheduleItems,
} from "../../view/Modules/CommercialSchedule/CommercialScheduleDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";
import { CommercialListParams } from "../../view/Modules/Commercials/CommercialDataTypes";

export const CommercialScheduleServices = {
  getCommercialSchedules: (params: CommercialScheduleListParams) => {
    return AxiosInstance.get(ContentApiRoutes.COMMERCIAL_SCHEDULES, { params });
  },
  getCommercialScheduleItems: (id: number, params: CommercialListParams) => {
    return AxiosInstance.get(
      ContentApiRoutes.COMMERCIAL_SCHEDULE_ITEMS.replace(":id", id.toString()),
      { params }
    );
  },
  createCommercialSchedule: (data: CommercialScheduleFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_COMMERCIAL_SCHEDULE, data),
  updateCommercialSchedule: (id: number, data: CommercialScheduleFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_COMMERCIAL_SCHEDULE.replace(
        ":id",
        id.toString()
      ) + "?_method=PUT",
      data
    ),
  addItemsToCommercialSchedule: (id: number, data: CommercialScheduleItems) =>
    AxiosInstance.post(
      ContentApiRoutes.ADD_ITEMS_TO_COMMERCIAL_SCHEDULE.replace(
        ":id",
        id.toString()
      ) + "?_method=PUT",
      data
    ),
  deleteItemsFromCommercialSchedule: (
    id: number,
    data: CommercialScheduleItems
  ) =>
    AxiosInstance.post(
      ContentApiRoutes.DELETE_ITEMS_FROM_COMMERCIAL_SCHEDULE.replace(
        ":id",
        id.toString()
      ) + "?_method=PUT",
      data
    ),
  publishCommercialSchedule: (id: number, data: PublishParams) =>
    AxiosInstance.put(
      ContentApiRoutes.PUBLISH_COMMERCIAL_SCHEDULE.replace(
        ":id",
        id.toString()
      ),
      data
    ),

  deleteCommercialSchedule: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_COMMERCIAL_SCHEDULE.replace(":id", id.toString())
    ),
  deleteTimeSlot: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_TIME_SLOT.replace(":id", id.toString())
    ),
  viewCommercialSchedule: (id: number) => {
    return AxiosInstance.get(
      ContentApiRoutes.VIEW_COMMERCIAL_SCHEDULE.replace(":id", id.toString())
    );
  },

  searchCommercialSchedules: (commercialSchedule: string) =>
    AxiosInstance.get(
      ContentApiRoutes.COMMERCIAL_SCHEDULES +
        `?smart_search=${commercialSchedule}`
    ),
};
